import { useEffect, useState } from 'react';
import '../../AdminDashboardV3/assets/map/sandy/animations.css';
import './BuffaloAvatar.css';
import useVisibleSprite from './useVisibleSprite';

// The same sprite and gestures as the admin buffalo, without nesting a button
// inside the many buttons that use the shared assistant avatar.
export default function BuffaloAvatar({ size = 64, mood = 'wave', interactive = false }) {
  const [ref, visible] = useVisibleSprite();
  const [gesture, setGesture] = useState(mood);
  const [replay, setReplay] = useState(0);
  useEffect(() => { setGesture(mood); }, [mood]);
  const Tag = interactive ? 'button' : 'span';
  return <Tag ref={ref} className={`teacher-buffalo${visible ? '' : ' is-paused'}`} role={interactive ? undefined : 'img'} type={interactive ? 'button' : undefined}
    aria-label={interactive ? 'Buffy the buffalo — click to jump' : 'Buffy the buffalo'}
    onClick={interactive ? () => { setGesture('jump'); setReplay(n => n + 1); } : undefined}
    style={{ width: size, height: size, '--buffalo-scale': size / 64 }}>
    <span className="teacher-buffalo-stage" aria-hidden="true">
      {gesture ? <span key={`${gesture}-${replay}`} className="om-buffalo" data-animation={gesture} onAnimationEnd={() => setGesture(null)} />
        : <span className="om-buffalo-idle" />}
    </span>
  </Tag>;
}
